var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g2, _g3, _path1, _path10, _g4, _path11, _path12, _g5, _g6, _g7, _g8, _path13, _path14, _path15, _g9, _g0, _g1, _g10, _path16, _path17, _g11, _path18, _g12, _path19, _path20, _g13, _path21, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _path22, _g31, _g32, _g33, _g34, _path23, _g35, _g36, _g37, _g38, _path24, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _path25, _g46, _g47, _g48, _g49, _path26, _g50, _g51, _path27, _g52, _path28, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGptConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.8566 14H38.1434C28.1231 14 20 22.1231 20 32.1434V83.8566C20 93.8769 28.1231 102 38.1434 102H89.8566C99.8769 102 108 93.8769 108 83.8566V32.1434C108 22.1231 99.8769 14 89.8566 14Z",
    fill: "#F0F2F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_17724",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 14,
    width: 88,
    height: 88
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8566 14H38.1434C28.1231 14 20 22.1231 20 32.1434V83.8566C20 93.8769 28.1231 102 38.1434 102H89.8566C99.8769 102 108 93.8769 108 83.8566V32.1434C108 22.1231 99.8769 14 89.8566 14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_17724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.161 118C104.399 117.944 103.131 116.548 103.332 114.884C104.424 105.774 100.824 92.2705 90.1616 83.0157C88.8457 81.8751 88.8033 79.8175 90.074 78.4193C91.3475 77.0155 93.4597 76.8118 94.7841 77.9665C107.906 89.4318 111.001 105.247 109.744 115.085C109.53 116.755 107.926 118.057 106.161 118Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.5755 78.224C93.0051 77.8872 92.2286 78.0967 91.8389 78.6882C91.452 79.2797 91.5989 80.0297 92.1693 80.3637C98.9153 84.3345 108.694 103.631 106.155 118C106.155 118 106.158 118 106.161 118C107.127 118.031 108.045 117.655 108.714 117.032C110.798 101.757 100.785 82.4751 93.5755 78.224Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7151 68.9211C97.6332 68.089 97.2916 67.3276 96.7466 66.7276L70.8554 39.379C69.243 37.6752 67.8199 35.7789 66.6085 33.7214L66.2753 33.1553C65.4903 30.4298 64.1913 28.1458 62.7399 26.4024C61.3365 24.1693 59.645 22.4627 58.0383 21.857C50.8518 19.1428 39.1106 17.0937 37.3147 16.6833C34.7648 16.1003 26.1551 14.8154 22.6875 14.3059C25.8022 15.8144 27.9877 17.9654 30.0322 20.9173C30.8256 21.0079 32.9265 21.2598 32.9265 21.2598C33.7539 22.6721 37.2158 28.2958 37.3881 34.8535C37.6676 45.3989 33.0621 53.5585 24.235 54.9821C30.6139 55.6982 47.2035 57.2888 52.8313 56.4595C53.4949 56.3604 54.2686 56.1057 55.1044 55.701C55.8471 55.4604 56.5954 55.1604 57.3409 54.7953C58.1315 55.0076 58.8149 55.2708 59.1622 55.585C62.5451 58.6444 69.0906 64.4153 73.6425 70.6475C75.3593 72.9966 76.2488 75.224 76.7119 76.857C77.4066 79.3222 79.0077 81.4166 81.3034 82.5147C82.3002 82.993 83.2744 83.2958 83.9944 83.2392C86.0897 83.0779 88.8626 82.3987 91.4068 80.2958C97.3565 75.3683 97.9326 71.0947 97.7208 68.9267L97.7151 68.9211Z",
    stroke: "#9EACAF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6448 86.7488L83.9605 80.3581L94.6993 71.8475L99.9826 78.6826C101.07 80.0892 101.016 82.1128 99.8414 83.6327C99.0112 84.7053 97.9693 85.727 97.3706 86.1912C96.7522 86.6723 95.7837 87.094 94.5017 87.6459C92.7566 88.3988 90.7348 88.1356 89.6448 86.7459V86.7488Z",
    fill: "#1E272D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2046 82.4524C78.9088 81.3543 77.3106 79.2599 76.6131 76.7948C76.1528 75.1617 75.2605 72.9343 73.5437 70.5852C68.9918 64.3559 62.4491 58.5822 59.0634 55.5227C57.8774 54.45 52.8285 53.9859 52.8285 53.9859L63.8101 29.0798L66.5068 33.6619C67.7182 35.7195 69.1414 37.6158 70.7538 39.3196L96.6449 66.6682C97.1899 67.271 97.5316 68.0324 97.6135 68.8616C97.8281 71.0296 97.2521 75.3033 91.2995 80.2307C88.7582 82.3364 85.9824 83.0128 83.8871 83.1742C83.1671 83.2308 82.1929 82.9279 81.1961 82.4496L81.2046 82.4524Z",
    fill: "#EDEEEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 40.5C65.3168 50.7426 57.3243 56.6067 51.5299 56.3067C45.7581 56.0067 36.6289 47.2839 37.2925 39.0281C37.9673 30.6195 50.0588 20.2075 56 21C59.9363 21.5236 67.7679 29.5102 66.5 40.5Z",
    fill: "#9EACAF",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7847 37.4177C40.7625 46.4716 34.9088 53.0915 29.2895 51.9509C24.7771 51.0339 21.7952 45.0848 22.1905 38.0969C22.3854 34.6667 23.32 31.4459 24.7348 28.8081C25.596 27.2005 26.8272 26.1731 28.0781 26.0118L36.829 24.8769C38.1957 24.6986 39.4523 25.4259 40.2118 26.9146C41.6096 29.6656 42.2421 33.3591 41.7847 37.4177Z",
    fill: "#1E272D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7914 46.947C31.3735 47.5357 18.3361 44.9517 18.3361 44.9517L16.7915 44.5215C15.5152 44.1677 14.3744 42.9564 13.6345 41.2045C12.1182 37.6101 11.3444 33.1751 11.7991 28.6127C12.3469 23.1447 14.1767 18.6107 16.0093 16.5248C21.3434 10.4539 28.1628 17.8295 30.4529 21.7636C35.2816 30.0533 34.1266 43.6668 31.7914 46.947ZM16.0093 16.5276C21.3434 10.4567 28.1628 17.8324 30.4529 21.7664C35.2816 30.0562 34.1266 43.6696 31.7914 46.9499L16.0093 16.5276Z",
    fill: "#1E272D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2827 21.2598C31.7067 20.8013 22.4983 21.9051 22.4983 21.9051L20.8747 22.1428C19.5306 22.3381 18.2175 23.4108 17.2433 25.075C15.2441 28.4911 13.9451 32.8496 13.7814 37.4827C13.5075 45.2008 17.7826 54.7727 24.139 54.9199C31.0148 55.0812 37.0295 47.7254 37.4643 36.6337C37.6761 31.2506 34.8382 23.3004 32.2827 21.2598Z",
    fill: "#4F6B77"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0487 25.6977C28.0583 25.4316 18.4886 23.8099 20.886 19.757C25.1753 12.5059 30.8454 17.9541 32.9491 21.3844C35.7531 25.958 34.4514 25.9977 31.0487 25.6948V25.6977Z",
    fill: "#4F6B77"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.37
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8665 30.5996C34.9568 38.4818 29.5521 45.8122 22.4701 49.2396C20.9312 49.9839 19.3329 50.5585 17.6979 50.9802C19.412 53.3123 21.6117 54.8633 24.139 54.9227C29.9729 55.0585 35.1884 49.783 36.8996 41.3998C37.1198 37.6979 36.4732 33.9506 34.8693 30.5996H34.8665Z",
    fill: "#172228"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9491 21.3872C30.9471 18.1211 25.0341 11.5974 20.372 20.6938C21.2474 20.79 22.5012 18.155 24.7461 18.7975C26.7707 19.3777 27.5359 21.8372 33.2315 21.8542C33.144 21.7042 33.0508 21.5513 32.9519 21.39L32.9491 21.3872Z",
    fill: "#172228"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6952 53.5019L9.80267 52.5566L16.4809 20.6117L30.3908 22.1513C32.4634 22.4598 37.2356 28.109 36.4054 37.6243C35.4143 48.9905 27.711 53.4849 24.6952 53.4991V53.5019Z",
    fill: "#263C49"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3773 34.6893C20.7984 43.7744 15.4587 50.8188 9.81679 50.5981C4.55611 50.3915 0.811786 43.8621 1.14217 35.8752C1.33701 31.1883 2.41851 27.4241 4.60129 25.2335C6.23625 23.5919 8.69293 22.9862 11.0367 22.6608C13.4199 22.3296 15.9896 22.1202 17.8081 23.3683C20.4313 25.1655 21.719 29.2949 21.3773 34.6921V34.6893Z",
    fill: "#1E272D"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5528 33.7185C21.6427 35.6912 20.7278 39.0252 19.0025 39.8318C20.5443 38.595 21.3067 35.9431 20.5866 33.7779L20.5556 33.7185H20.5528Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66995 50.4821C7.90227 50.4113 6.23906 49.5821 4.86106 48.0849C2.42415 45.4414 1.09133 40.9781 1.29182 36.1497C1.4556 32.2412 2.57098 28.4543 4.43467 25.4854C5.55853 23.6967 9.97209 22.508 13.4171 22.4316C15.8371 22.3778 17.5793 22.8589 18.1949 23.7533C20.132 26.5609 21.0865 30.6789 20.8125 35.0488C20.5471 39.2715 19.2228 43.2084 17.0823 46.1405C16.0545 47.5499 14.8967 48.6452 13.643 49.3924C12.3497 50.1651 11.0169 50.5302 9.68124 50.4792C9.67559 50.4792 9.67277 50.4792 9.66712 50.4792L9.66995 50.4821ZM1.32288 36.1526H1.35112C1.15063 40.9668 2.4778 45.4131 4.90342 48.0452C6.27013 49.5311 7.91921 50.3519 9.67277 50.4226C9.67842 50.4226 9.68124 50.4226 9.68689 50.4226C12.3215 50.5217 14.9335 48.9905 17.04 46.1065C19.1719 43.1857 20.4935 39.2573 20.7589 35.0459C21.0328 30.6902 20.084 26.5864 18.1526 23.7872C17.5483 22.9099 15.8229 22.4372 13.4227 22.491C9.99186 22.5674 5.60089 23.7448 4.48833 25.5194C2.63028 28.4798 1.51772 32.2582 1.35394 36.1554H1.3257L1.32288 36.1526Z",
    fill: "#1E272D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2655 21.1891C17.7431 20.7391 17.1275 20.6032 16.4781 20.6117C13.9226 20.64 8.12253 21.7608 8.12253 21.7608L6.56945 21.99C5.28464 22.1797 4.04218 23.2127 3.13292 24.8203C1.27206 28.1203 0.0917209 32.3261 0.00418404 36.7978C-0.142652 44.247 3.5932 51.3396 8.39643 52.3896C14.8572 53.8048 21.4677 46.2027 22.4334 35.6488C22.9727 29.7477 21.3406 23.8438 18.2627 21.1891H18.2655Z",
    fill: "#4F6B77"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.08415 50.2018C0.399509 46.5961 -1.22698 37.0582 1.38218 29.2241C2.23496 26.6259 3.50001 24.2599 5.04179 22.4853C3.56213 24.3872 2.35074 26.759 1.54596 29.343C-0.938958 37.112 0.636706 46.2876 5.08132 50.2047L5.08415 50.2018Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7412 43.9979C71.7788 49.7773 81.5378 60.5435 94.0584 75.1504C95.0297 76.2825 91.4803 79.4637 90.1842 80.4458C87.5185 82.4665 83.3563 78.0457 82.1844 75.4759C79.338 69.4786 66.2668 48.6678 61.2066 53.9802C59.967 55.2821 62.2429 52.2651 64.55 48.9876C66.4165 46.3385 66.3939 45.3819 66.7412 44.0008V43.9979Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5334 57.3765C88.6593 60.2804 91.9772 62.9521 95.4448 65.3974L72.561 41.2244C72.5525 41.2781 72.5412 41.3234 72.5327 41.3829C72.304 43.4546 74.8906 45.7556 76.0144 47.1509C78.9568 50.8076 82.1392 54.2237 85.5334 57.3765Z",
    fill: "#6396A8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9925 43.6866C67.2325 45.3452 64.8916 48.3792 66.4306 50.5188C70.8413 56.652 84.1328 72.6457 86.5133 76.1523C87.1317 77.0608 87.0949 79.4382 85.1296 77.3693C79.8859 71.856 70.6437 57.4501 66.8626 54.5604C64.4483 52.7151 62.8275 52.6104 60.0122 54.2576C59.7891 54.3878 59.3966 54.1246 59.5801 53.9378C62.226 51.2604 65.2164 48.3565 66.3656 45.2716C66.456 45.0338 66.9586 43.4376 66.9925 43.6838V43.6866Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5101 87.6431C95.7865 87.0912 96.7522 86.6723 97.3706 86.194C97.9693 85.7299 99.0084 84.7082 99.8414 83.6355C100.872 82.3053 101.039 80.5902 100.336 79.2373C100.804 81.2638 99.2626 84.0629 96.4727 85.9704C95.394 86.7091 91.9292 87.8186 90.5823 87.5639C91.1357 87.9261 91.7852 87.9488 92.4601 87.9997C93.1067 87.9799 93.7986 87.8667 94.5101 87.6488V87.6431Z",
    fill: "#436675"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.463 77.9071L98.647 76.8514C98.5199 76.7495 98.3928 76.6476 98.2488 76.5656C98.3448 76.6703 98.4352 76.7807 98.5171 76.9024C99.8612 78.9147 98.2996 82.3591 95.0579 84.5836C93.0248 85.9789 90.8703 86.4714 89.176 86.2195L89.6081 86.7035C91.3362 87.0884 93.5952 86.6157 95.7639 85.1299C98.7797 83.0638 100.338 79.9505 99.4687 77.9071H99.463Z",
    fill: "#436675"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9584 74.89C97.0544 74.9948 97.1447 75.1051 97.2266 75.2268C98.5736 77.2448 97.0177 80.7005 93.7731 82.9336C91.7005 84.3628 89.45 84.8949 87.7416 84.6063L88.2329 85.1581C89.9695 85.5883 92.2681 84.9997 94.4763 83.4798C97.3932 81.4732 98.9407 78.4844 98.246 76.4353L97.1673 75.0372C97.0967 74.9891 97.0346 74.9297 96.9555 74.8872L96.9584 74.89Z",
    fill: "#436675"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.2189 82.9223C96.7042 81.7138 97.7405 80.2562 98.1754 78.8779L97.5146 78.176C97.1165 79.5684 96.0971 81.0515 94.6146 82.2855L95.2161 82.9223H95.2189Z",
    fill: "#6396A8"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.659 84.4421C98.1415 83.1968 99.1524 81.7081 99.5308 80.3156L98.8701 79.6137C98.5312 81.0175 97.5372 82.5345 96.0576 83.8081L96.659 84.4421Z",
    fill: "#6396A8"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.8931 85.7468C98.4776 85.2148 99.2174 84.4393 99.8415 83.6327C100.327 83.0072 100.615 82.2911 100.714 81.5722L100.262 81.0939C99.9007 82.4892 98.9011 83.9921 97.4158 85.2459L97.8902 85.7468H97.8931Z",
    fill: "#6396A8"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5 51.1415C76.4606 57.9029 83.1021 64.9502 89.32 72.1702C82.4865 65.5417 75.8507 58.5029 69.5 51.1415Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9042 14.6597L20.3381 14.0031C24.0373 14.47 27.4371 17.6767 29.8712 20.8466L33.6155 21.506C32.1076 19.2899 30.066 16.4059 24.907 14.6597H24.9042Z",
    fill: "#263C49"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5841 28.5675L11.4433 28.4514C11.9403 23.4872 13.595 18.772 15.6563 16.4399C17.2433 14.6399 19.0844 13.8248 21.126 14.0314C25.1838 14.4304 28.6316 18.6135 29.9362 20.8579L28.6062 20.906C27.4004 18.8371 24.6105 15.5314 21.013 15.1748C19.3583 15.0163 17.8448 15.6927 16.5148 17.2012C14.9476 18.9758 13.1234 23.1787 12.5841 28.5675Z",
    fill: "#4F6B77"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.30722 22.6948C8.01522 21.8796 10.9209 21.2966 13.7334 21.0362C14.829 20.9513 15.902 20.8749 17.0033 21.0164C18.8698 21.407 19.4684 23.1929 19.4684 23.1929C18.5648 22.0353 17.3167 21.3617 15.8879 21.5372C13.7616 21.6278 11.6522 21.9164 9.54005 22.1768C8.48679 22.3183 6.36049 22.5787 5.30722 22.6948Z",
    fill: "#6396A8"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99546 35.7365C7.92769 33.0138 9.28592 30.5996 11.0254 30.359C12.7648 30.1185 14.2106 32.1449 14.2586 34.8648C14.3066 37.5677 12.9512 39.9422 11.2343 40.1856C9.51465 40.429 8.06323 38.4422 7.99828 35.7365H7.99546Z",
    fill: "#263238"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5756 39.512C13.6006 38.578 14.2896 36.8063 14.2557 34.8676C14.2106 32.244 12.8636 30.2685 11.2061 30.3477C10.1698 31.293 9.48075 33.0902 9.52876 35.0487C9.5937 37.6554 10.9406 39.5884 12.5756 39.512Z",
    fill: "#172228"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.600005 36.7667C0.509644 34.0411 1.85376 31.6241 3.60167 31.3807C5.34676 31.1401 6.82077 33.1666 6.89137 35.8893C6.96196 38.595 5.62067 40.9724 3.89535 41.2158C2.1672 41.4592 0.693189 39.4724 0.602829 36.7638L0.600005 36.7667Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0.600005 36.7667C0.509644 34.0411 1.85376 31.6241 3.60167 31.3807C5.34676 31.1401 6.82077 33.1666 6.89137 35.8893C6.96196 38.595 5.62067 40.9724 3.89535 41.2158C2.1672 41.4592 0.693189 39.4724 0.602829 36.7638L0.600005 36.7667Z",
    fill: "#263238"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.89136 35.8922C6.82076 33.1695 5.34958 31.143 3.60166 31.3836C3.5706 31.3864 3.54236 31.3949 3.5113 31.4006C2.5964 32.3883 2.0147 34.0723 2.07683 35.8978C2.16719 38.6064 3.6412 40.5932 5.36934 40.3498C5.39758 40.347 5.423 40.3413 5.45123 40.3356C6.35484 39.3592 6.93654 37.7007 6.89136 35.895V35.8922Z",
    fill: "#172228"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9504 34.7686C14.9052 32.0487 16.2747 29.6374 18.0057 29.3996C19.7367 29.1619 21.1599 31.1827 21.1825 33.9025C21.2079 36.6026 19.8412 38.9743 18.1328 39.2149C16.4188 39.4555 14.9956 37.4743 14.9504 34.7714V34.7686Z",
    fill: "#263238"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1853 33.8997C21.1599 31.1827 19.7367 29.159 18.0086 29.3968C17.9973 29.3968 17.986 29.4024 17.9747 29.4024C16.8423 30.2996 16.0658 32.1817 16.0997 34.2393C16.1449 36.9422 17.5709 38.9262 19.2821 38.6828C19.2905 38.6828 19.299 38.68 19.3075 38.6771C20.4257 37.7913 21.2022 35.9375 21.1853 33.894V33.8997Z",
    fill: "#172228"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4551 39.1894C17.489 39.1951 17.52 39.2035 17.5539 39.2064C17.52 39.2007 17.4861 39.1951 17.4551 39.1894Z",
    fill: "#1E272D"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1784 39.113C17.2094 39.1243 17.2405 39.1328 17.2687 39.1413C17.2377 39.1328 17.2066 39.1243 17.1784 39.113Z",
    fill: "#1E272D"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7516 39.2262C17.7826 39.2262 17.8109 39.2319 17.8419 39.2319C17.8109 39.2319 17.7826 39.229 17.7516 39.2262Z",
    fill: "#1E272D"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9283 35.9516C20.9424 35.9007 20.9566 35.8497 20.9678 35.7988C20.9566 35.8497 20.9396 35.9007 20.9283 35.9516Z",
    fill: "#1E272D"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8013 36.3733C20.8182 36.3195 20.838 36.2657 20.8549 36.212C20.838 36.2657 20.821 36.3195 20.8013 36.3733Z",
    fill: "#1E272D"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6573 36.761C20.677 36.7101 20.6968 36.662 20.7166 36.611C20.6968 36.662 20.6798 36.7129 20.6573 36.761Z",
    fill: "#1E272D"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3442 38.6545C19.3272 38.6686 19.3103 38.6771 19.2962 38.6913C19.3131 38.6771 19.3301 38.6686 19.3442 38.6545Z",
    fill: "#1E272D"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6576 38.3601C19.635 38.3856 19.6096 38.4111 19.587 38.4365C19.6125 38.4139 19.635 38.3856 19.6576 38.3601Z",
    fill: "#1E272D"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0844 38.8441C19.0533 38.8639 19.0251 38.8809 18.994 38.8979C19.0251 38.8809 19.0562 38.8611 19.0844 38.8441Z",
    fill: "#1E272D"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9157 38.9969C16.9327 39.0054 16.9496 39.0111 16.9637 39.0196C16.9468 39.0111 16.9299 39.0054 16.9157 38.9969Z",
    fill: "#1E272D"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9061 38.0771C19.8779 38.1111 19.8496 38.1478 19.8214 38.1818C19.8496 38.1478 19.8779 38.1139 19.9061 38.0771Z",
    fill: "#1E272D"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8105 38.9969C18.7766 39.0139 18.7456 39.0281 18.7117 39.0422C18.7456 39.0281 18.7766 39.0111 18.8105 38.9969Z",
    fill: "#1E272D"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3397 38.5781C16.3679 38.6035 16.3962 38.6318 16.4244 38.6573C16.3962 38.6318 16.3679 38.6064 16.3397 38.5781Z",
    fill: "#1E272D"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1138 38.3431C16.1392 38.3743 16.1675 38.4026 16.1957 38.4337C16.1675 38.4054 16.142 38.3743 16.1138 38.3431Z",
    fill: "#1E272D"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.18823 33.0903C7.65377 35.4252 7.14549 39.4668 5.21968 40.6583C6.88571 38.963 7.39963 35.9545 6.18823 33.0903Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.15307 40.8083C0.958613 40.0979 0.48422 38.479 0.470101 36.8432C0.453158 34.9412 1.09133 32.9855 2.45804 31.9242C0.0917154 33.7639 0.0211211 38.8668 2.15307 40.8083Z",
    fill: "white"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90061 36.4978C4.88366 35.9148 5.17169 35.3968 5.54442 35.3459C5.91716 35.2949 6.23342 35.7251 6.25037 36.311C6.26731 36.894 5.97929 37.4091 5.60655 37.4601C5.23381 37.511 4.91755 37.0808 4.89778 36.4978H4.90061Z",
    fill: "url(#paint0_linear_6_17724)"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.27745 27.2203C9.23509 25.3467 8.2383 23.9542 7.05232 24.1155C7.02126 24.1183 6.99302 24.1297 6.96196 24.1353C6.31814 24.8061 5.90304 25.9778 5.93975 27.2542C5.99058 29.1194 6.99019 30.4949 8.16771 30.3335C8.19595 30.3307 8.22418 30.3194 8.25524 30.3137C8.89342 29.6486 9.30851 28.4882 9.28027 27.2203H9.27745Z",
    fill: "#172228"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99662 27.8062C4.94296 25.9326 5.86351 24.2769 7.05232 24.1155C8.2383 23.9542 9.2351 25.3495 9.27745 27.2203C9.31981 29.0854 8.40208 30.7213 7.22457 30.8826C6.04706 31.044 5.05027 29.6713 4.99662 27.8033V27.8062Z",
    fill: "#1E272D"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.80588 25.2929C9.79985 26.9005 9.44405 29.6854 8.131 30.5005C9.2718 29.3345 9.62477 27.2656 8.80588 25.2929Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.03858 30.5968C5.22816 30.1043 4.90907 28.9864 4.90625 27.8571C4.90342 26.5495 5.34111 25.208 6.27295 24.4835C4.66058 25.7401 4.59563 29.2496 6.03858 30.5968Z",
    fill: "white"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09146 27.5684C8.08017 27.1665 8.27783 26.8127 8.53197 26.7788C8.78611 26.7448 9.00072 27.042 9.00919 27.4439C9.02049 27.8458 8.82282 28.1995 8.56868 28.2335C8.31454 28.2675 8.09994 27.9703 8.09146 27.5684Z",
    fill: "url(#paint1_linear_6_17724)"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5446 26.7731C12.5078 24.9023 13.4369 23.2495 14.62 23.0882C15.8004 22.9268 16.7802 24.3193 16.8056 26.1901C16.831 28.0524 15.9048 29.6883 14.733 29.8496C13.5611 30.0109 12.5813 28.6383 12.5446 26.7731Z",
    fill: "#1E272D"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8056 26.1901C16.7802 24.3193 15.8004 22.9268 14.62 23.0882C14.589 23.091 14.5607 23.1023 14.5297 23.108C13.8858 23.7787 13.4623 24.9476 13.4877 26.2212C13.5244 28.0835 14.5042 29.459 15.6761 29.2977C15.7043 29.2949 15.7326 29.2836 15.7636 29.2779C16.4018 28.6128 16.8254 27.4552 16.8084 26.1901H16.8056Z",
    fill: "#172228"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3538 24.2655C17.328 25.8731 16.9496 28.6524 15.6366 29.4675C16.7802 28.3043 17.1501 26.2354 16.3538 24.2655Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5583 29.5609C12.7563 29.0684 12.4514 27.9505 12.457 26.824C12.4655 25.5193 12.9116 24.1778 13.8435 23.4561C12.2311 24.7099 12.1351 28.2137 13.5583 29.5609Z",
    fill: "white"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6309 26.5382C15.6253 26.1363 15.8229 25.7825 16.0771 25.7486C16.3312 25.7146 16.5402 26.0118 16.5458 26.4137C16.5515 26.8156 16.3538 27.1665 16.0997 27.2033C15.8484 27.2373 15.6366 26.9401 15.6309 26.541V26.5382Z",
    fill: "url(#paint2_linear_6_17724)"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16923 45.897C4.09016 43.2338 5.42581 40.8649 7.15113 40.6215C8.87363 40.3781 10.3166 42.3536 10.3759 45.014C10.4352 47.6575 9.10236 49.9896 7.39962 50.233C5.69407 50.4792 4.2483 48.5433 4.16923 45.897Z",
    fill: "#1E272D"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.69253 42.28C11.1298 44.5555 10.6103 48.5093 8.70703 49.681C10.3589 48.0169 10.8757 45.0734 9.69253 42.28Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.68278 49.8424C4.50809 49.1546 4.04499 47.5725 4.03934 45.9734C4.03087 44.114 4.66904 42.2007 6.01881 41.1564C3.6779 42.9649 3.58754 47.9518 5.68278 49.8424Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8838 44.7989C11.8301 42.1385 13.1771 39.7724 14.8939 39.5319C16.608 39.2913 18.0255 41.2611 18.0594 43.9216C18.0933 46.5622 16.7491 48.8915 15.0549 49.1349C13.3578 49.3783 11.9374 47.4452 11.8838 44.8018V44.7989Z",
    fill: "#1E272D"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16925 45.897C4.09018 43.2338 5.42582 40.8649 7.15115 40.6215C8.87365 40.3781 10.3166 42.3536 10.3759 45.014C10.4352 47.6575 9.10237 49.9896 7.39964 50.233C5.69408 50.4792 4.24831 48.5433 4.16925 45.897Z",
    fill: "#1E272D"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8838 44.7989C11.8301 42.1385 13.1771 39.7724 14.8939 39.5319C16.608 39.2913 18.0255 41.2611 18.0594 43.9216C18.0933 46.5622 16.7491 48.8915 15.0549 49.1349C13.3578 49.3783 11.9374 47.4452 11.8838 44.8018V44.7989Z",
    fill: "#1E272D"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3759 45.014C10.3166 42.3536 8.87365 40.3781 7.15115 40.6215C6.95913 40.6498 6.77558 40.7036 6.59486 40.78C5.85786 41.7706 5.40605 43.2479 5.45406 44.83C5.53312 47.4763 6.9789 49.4122 8.68445 49.166C8.87365 49.1377 9.05437 49.0839 9.23226 49.0103C9.9608 48.0339 10.4126 46.5791 10.3787 45.014H10.3759Z",
    fill: "#172228"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0622 43.9215C18.0283 41.2639 16.6108 39.2913 14.8968 39.5318C14.7895 39.546 14.685 39.5714 14.5805 39.5998C13.7898 40.5875 13.29 42.113 13.3239 43.7545C13.3776 46.398 14.7979 48.331 16.495 48.0876C16.5995 48.0735 16.7011 48.0508 16.8028 48.0197C17.585 47.0433 18.0848 45.5404 18.0622 43.9187V43.9215Z",
    fill: "#1E272D"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4099 41.1876C18.8161 43.4602 18.2655 47.4084 16.3651 48.5801C18.0198 46.916 18.562 43.9782 17.4099 41.1876Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.355 48.7415C12.1916 48.0537 11.7483 46.4744 11.7567 44.8753C11.7652 43.0187 12.4147 41.1083 13.7673 40.0668C11.4235 41.8725 11.2908 46.8537 13.355 48.7415Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5387 31.1034C21.9505 33.4327 21.3801 37.4658 19.4572 38.6545C21.1345 36.962 21.6908 33.9619 20.5387 31.1034Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4188 38.8045C15.2497 38.0941 14.8064 36.478 14.8205 34.845C14.8375 32.9487 15.4982 30.9958 16.8678 29.9373C14.4986 31.7713 14.3433 36.8629 16.4216 38.8045H16.4188Z",
    fill: "white"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2284 34.5025C19.2199 33.9195 19.5136 33.4044 19.8835 33.3535C20.2535 33.3025 20.5612 33.7327 20.5669 34.3157C20.5754 34.8988 20.2789 35.411 19.9118 35.462C19.5419 35.5129 19.2369 35.0827 19.2284 34.5025Z",
    fill: "url(#paint3_linear_6_17724)"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5809 32.0656C13.7616 32.3572 13.9084 32.677 14.0299 33.0109C14.8629 35.3629 14.2388 38.5837 12.5558 39.6224C14.2275 37.9271 14.7612 34.9242 13.5837 32.0628L13.5809 32.0656Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50334 39.7752C8.32018 39.0648 7.86273 37.4488 7.86273 35.8129C7.86273 33.9138 8.51502 31.9609 9.88173 30.8996C7.51258 32.7364 7.39963 37.8337 9.50334 39.7752Z",
    fill: "white"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9798 35.5101C11.96 34.6638 12.3836 33.9166 12.9229 33.8402C13.4623 33.7666 13.9141 34.3921 13.931 35.2384C13.948 36.0818 13.5244 36.8261 12.9879 36.9026C12.4485 36.979 11.9996 36.3563 11.9798 35.5101Z",
    fill: "url(#paint4_linear_6_17724)"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.438 21.4041L28.6061 20.906L29.9361 20.8579L33.2428 21.4409L32.438 21.4041Z",
    fill: "#263C49"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7303 34.8959C65.0723 29.1901 61.3167 23.0711 57.9395 21.7975C50.753 19.0833 39.0117 17.0342 37.2158 16.6239C34.666 16.0408 26.0563 14.7559 22.5887 14.2465C25.7033 15.755 27.8889 17.906 29.9333 20.8579C30.7268 20.9485 32.8277 21.2004 32.8277 21.2004C33.655 22.6126 37.117 28.2363 37.2892 34.794C37.5688 45.3395 32.9632 53.4991 24.1361 54.9227C30.515 55.6387 47.1047 57.2293 52.7324 56.4001C57.307 55.7265 67.1873 47.5216 65.7303 34.8987V34.8959Z",
    fill: "#EDEEEF"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8399 28.0212C56.0391 25.5788 51.4787 24.6957 47.0425 23.8608C44.3091 23.3457 41.5729 22.8306 38.8395 22.3183C37.1791 22.007 34.8721 21.1296 33.1722 21.7777C34.3497 23.7985 37.1396 28.9184 37.2921 34.7912C37.4078 39.229 36.6595 43.2394 35.098 46.5084C41.7 47.4027 54.9463 48.6056 58.5889 47.6348C62.5281 46.5848 64.7928 44.1847 65.6597 40.3979C65.8319 39.2233 65.9082 37.995 65.8658 36.7129C65.3603 33.2034 62.8895 29.9798 59.8399 28.0184V28.0212Z",
    fill: "#6396A8"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7797 23.858C32.6329 23.8212 32.4917 23.7646 32.342 23.7504C29.1483 23.4589 24.0175 22.7995 19.8835 23.0683C21.8941 26.125 22.8739 30.8883 22.4362 35.6459C22.199 38.2356 21.6202 40.6498 20.79 42.7951C23.9978 43.1461 30.7325 43.8225 34.9427 44.0376C35.6656 42.2036 36.1936 40.0724 36.4054 37.6243C36.9843 30.9845 34.8354 26.2326 32.7797 23.858Z",
    fill: "#6396A8"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8052 37.7148C62.6298 35.8355 61.7403 33.5515 60.2155 32.1789C58.6906 30.8062 56.6688 30.1552 54.6978 29.6005C50.0245 28.2958 45.2777 27.291 40.4716 26.6316C39.4297 26.4872 36.9222 25.8221 35.2081 25.8278C36.236 28.2646 37.2045 31.4034 37.2921 34.7912C37.3401 36.5884 37.2412 38.3176 37.0069 39.9535C42.8125 40.4856 48.6436 40.7488 54.4747 40.7347C55.8753 40.7318 57.3013 40.7092 58.6398 40.2903C59.9783 39.8714 61.2405 38.9997 61.8052 37.7148Z",
    fill: "#6396A8"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4244 36.2092C61.2094 35.0573 60.2973 33.6252 58.7781 32.7506C57.2589 31.8761 55.2597 31.4431 53.3141 31.0695C48.7001 30.1921 44.0155 29.4987 39.28 29.0175C38.6418 28.9524 37.4445 28.7543 36.2247 28.61C36.8007 30.4808 37.2328 32.5808 37.2921 34.7884C37.3146 35.646 37.3034 36.4894 37.261 37.313C42.5838 37.6781 47.9236 37.9017 53.2577 37.9724C54.6357 37.9922 56.0362 37.9979 57.3465 37.7573C58.6567 37.5168 59.885 36.996 60.4216 36.2063L60.4244 36.2092Z",
    fill: "#B4CBD1"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4054 37.6243C36.8262 32.8072 35.8096 28.9836 34.4344 26.3401C30.6252 26.0345 24.5823 25.5873 21.2644 25.542C21.2248 25.542 21.1853 25.542 21.1458 25.542C22.2809 28.4119 22.7694 32.0289 22.439 35.6488C22.3797 36.2828 22.3007 36.9054 22.2047 37.5167C25.243 37.9215 28.2814 38.329 31.317 38.7337C32.9463 38.9517 34.618 39.1639 36.2416 39.0309C36.3066 38.5724 36.3659 38.1054 36.4054 37.6243Z",
    fill: "#6396A8"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5739 36.3846C33.1863 36.5827 34.8241 36.7809 36.4534 36.9224C36.6313 33.9535 36.2614 31.3808 35.6119 29.2524C31.6784 28.8505 26.4149 28.3269 21.8912 27.9109C22.4475 30.1751 22.6593 32.7138 22.4645 35.2667C25.5 35.6403 28.5384 36.0139 31.5739 36.3846Z",
    fill: "#6396A8"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7353 56.3973C54.4804 56.1397 56.9963 54.7869 59.3598 52.5114C48.8356 55.0161 37.8512 55.5652 27.1293 54.1218C26.1918 54.4784 25.195 54.7501 24.1361 54.9199C30.515 55.6359 47.1047 57.2265 52.7324 56.3973H52.7353Z",
    fill: "#6396A8"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9423 21.7975C50.7558 19.0833 39.0146 17.0314 37.2187 16.6239C34.6688 16.0408 26.0591 14.7559 22.5915 14.2465C23.7944 14.8295 24.8562 15.5059 25.8247 16.2899C37.9387 18.0333 49.8946 20.8579 61.5059 24.7325C60.3736 23.3061 59.1339 22.2504 57.9423 21.8004V21.7975Z",
    fill: "#6396A8"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4764 51.7189C12.2904 52.2906 11.0536 52.5821 9.80832 52.5566L24.6952 53.4991C25.6864 53.4934 27.183 53.0038 28.7784 51.9481C23.6787 51.8717 18.579 51.7953 13.4764 51.7189Z",
    fill: "#6396A8"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6521 50.1848C42.0671 50.3094 36.6341 49.7744 33.1637 49.6499C32.1895 50.8896 31.0487 51.9481 29.7441 52.7943C33.7934 53.8896 49.1745 54.2179 56.4853 53.1566C58.3038 52.8934 59.95 51.9594 61.1247 50.5443C62.0678 49.4122 63.1324 47.9772 63.6181 46.7772C59.1368 49.7999 53.396 50.0971 48.6549 50.1848H48.6521Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3018 45.9055C18.2429 47.7254 16.9807 49.2395 15.5942 50.3603C19.4148 50.6999 27.6884 51.2773 30.1846 50.8839C31.3791 49.8594 32.5651 48.5122 33.5816 46.8084C31.4808 46.7687 27.3242 46.5084 19.299 45.9083L19.3018 45.9055Z",
    fill: "#172228"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7569 21.7919C23.2382 27.0816 23.1732 36.594 20.9876 42.8772C19.9824 45.6508 18.3107 48.2263 16.0178 50.0914C14.877 50.9999 13.6063 51.7924 12.2085 52.217C14.1626 51.3141 15.8371 49.8594 17.184 48.198C18.5225 46.5367 19.5362 44.6234 20.2139 42.6026C22.2301 36.4186 22.4616 27.3674 18.7597 21.7919H18.7569Z",
    fill: "#6396A8"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8803 24.8259C24.0373 30.8572 23.2551 39.7866 19.9485 45.2659C19.7282 45.6282 18.8811 46.8565 18.6552 47.2131C22.648 40.8734 23.1563 32.3176 21.1712 25.6184L20.8803 24.8259Z",
    fill: "#172228"
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2537 23.8693C38.9383 30.993 38.1082 41.8271 34.9455 47.0886C34.7281 47.4537 33.1779 49.5735 32.9435 49.9245C37.0154 43.8366 38.1223 34.2845 35.7221 27.7212C35.5159 27.158 34.2537 23.8693 34.2537 23.8693Z",
    fill: "#6396A8"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7353 56.3972C56.3356 55.868 63.2228 50.6688 65.2813 42.3224C61.4749 47.4593 59.9811 51.0169 52.3371 54.5491C49.7167 55.7576 44.9558 55.9868 42.1094 56.4453C46.5004 56.6746 50.4904 56.7312 52.7353 56.4001V56.3972Z",
    fill: "#6396A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_17724",
    x1: 4.90061,
    y1: 36.4016,
    x2: 6.25319,
    y2: 36.4016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_17724",
    x1: 8.09146,
    y1: 27.5061,
    x2: 9.01201,
    y2: 27.5061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_17724",
    x1: 15.6309,
    y1: 26.4759,
    x2: 16.5458,
    y2: 26.4759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_17724",
    x1: 19.2284,
    y1: 34.4063,
    x2: 20.5697,
    y2: 34.4063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_17724",
    x1: 11.9798,
    y1: 35.3714,
    x2: 13.931,
    y2: 35.3714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGptConnector);
export default __webpack_public_path__ + "static/media/gpt_connector.9efa21186f7b66c134bda0c3c3eb0e87.svg";
export { ForwardRef as ReactComponent };